module.exports = "/_next/static/images/xrp-bede06b55e6fe409028cea750531d706.svg";